import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const communicationType = [
  { id: 1, label: 'Email' },
  { id: 2, label: 'Email incl. Report' },
  { id: 3, label: 'Fax' },
  { id: 4, label: 'Fax incl. Report' },
  { id: 5, label: 'In Person' },
  { id: 6, label: 'Letter' },
  { id: 7, label: 'Letter incl. Report' },
  { id: 8, label: 'Phone Call' },
  { id: 9, label: 'SMS Text' },
  { id: 10, label: 'Social Media Call' },
  { id: 11, label: 'Social Media Text' },
  { id: 12, label: 'Other' }
]

export const communicationDirection = [
  { id: 1, label: 'Incoming	Email' },
  { id: 2, label: 'Outgoing Email incl. Report' }
]

export const valueTable = {
  communicationType,
  communicationDirection
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'communication.date',
      'communication.direction',
      'communication.type',
      'communication.initiated',
      'communication.theirRoleInitiated',
      'communication.notes'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Namewww '
  },
  {
    name: 'communication.date',
    title: 'Communication Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.time',
    title: 'Communication Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.direction',
    title: 'Communication Direction',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.communicationDirection, [
        'id',
        parseInt(row[`communication.direction`], 10)
      ])
        ? _.find(valueTable.communicationDirection, [
            'id',
            parseInt(row[`communication.direction`], 10)
          ]).label
        : row[`communication.direction`],
    options: 'communicationDirection',
    filterField: true,
    minSpace: 'Communication Dir'
  },
  {
    name: 'communication.type',
    title: 'Communication Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.communicationType, [
        'id',
        parseInt(row[`communication.type`], 10)
      ])
        ? _.find(valueTable.communicationType, [
            'id',
            parseInt(row[`communication.type`], 10)
          ]).label
        : row[`communication.type`],
    options: 'communicationType',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.initiated',
    title: 'Communication Initiated By Name(s)',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Initiated By Name(s) '
  },
  {
    name: 'communication.theirRoleInitiated',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, [
        'id',
        parseInt(row[`communication.theirRoleInitiated`], 10)
      ])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`communication.theirRoleInitiated`], 10)
          ]).label
        : row[`communication.theirRoleInitiated`],
    minSpace: 'Their Role ',
    options: 'theirRole',
    filterField: true
  },
  {
    name: 'communication.intended',
    title: 'Communication Intended to Reach Name',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Intended to Reach Name '
  },
  {
    name: 'communication.theirRoleIntended',
    title: 'Their Role',
    formField: true,
    type: 'select',
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'communication.recipient',
    title: 'Actual Communication Recipient Name',
    formField: true,
    type: 'select',
    // options: 'personnel', //FROM PERSONNEL REGISTER
    filterField: true,
    minSpace: 'Actual Communication '
  },
  {
    name: 'communication.theirRoleRecipient',
    title: 'Their Role',
    formField: true,
    //AUTO CALC BASE ON PERSONNEL ROLE & STATUS ROLE
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'communication.notes',
    title: 'Communication Notes',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Communication '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'communication',
      historyName: 'communicationHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },

    {
      id: 2,
      name: 'com',
      activeName: 'communication',
      historyName: 'communicationHistory',
      label: 'Communication',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.date',
            label: 'Communication Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.time',
            label: 'Communication Time',
            minutesStep: 1,
            required: showAsterix,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.direction',
            label: 'Communication Direction',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.communicationDirection
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.type',
            label: 'Communication Type',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.communicationType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'communication.initiated',
            label: 'Communication Initiated By Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleInitiated',
            label: 'Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'communication.intended',
            label: 'Communication Intended to Reach Name',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleIntended',
            label: 'Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.recipient',
            label: 'Actual Communication Recipient Name',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            // options: availableValues.personnel.filter(f => f.id > 0).map(o => {
            //   return { value: o.id, label: o.label }
            // }),
            options: availableValues.users.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            }),
            onChange: (e, v) => {
              change(formName, 'communication.theirRoleRecipient', v)
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleRecipient',
            label: 'Their Role',
            disabled: true,
            required: showAsterix
          }
        ],

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'communication.notes',
          label: 'Communication Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['communication']

export const errors = [1, 2]

export const defaultNew = {
  communication: {
    historyId: 'new',
    date: new Date(),
    time: new Date(),
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  communicationHistory: []
}

// "communications": [
//   {
// "communication": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "type" : 2,
//   "direction" : 2,
//   "initiated": "aaa",
//   "theirRoleInitiated" : 2,
//   "intended": "daa",
//   "theirRoleIntended": 2,
//   "recipient" :2,
//   "theirRoleRecipient": 1,
//   "notes": "aa"
// },
// "communicationHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/communications.js